import React from "react";
import {useTranslation} from "react-i18next";
import Header from "./Header";
import PoweredBy from "./PoweredBy";
import {Progress} from "@nextui-org/react";
import {LocationIcon} from "../icons/LocationIcon";

function LocationLoading() {
    const {t} = useTranslation();
    return (
        <div className="flex flex-col w-full h-full justify-between">
            <Header closeEnabled={false}/>
            <div className="flex flex-col items-center gap-4 mb-10 p-10">
                <LocationIcon/>
                <div className="desc">{t("common.locationLoading.fetching")}</div>
                <Progress
                    size="sm"
                    isIndeterminate
                    aria-label={t("common.locationLoading.ariaLabel")}
                    className="max-w-md"
                />
            </div>
            <div className="flex flex-row justify-center p-4">
                <PoweredBy/>
            </div>
        </div>

    );
}

export default LocationLoading;
